//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelWages', {
//        templateUrl: 'views/components/views/travelWages/travelWages.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'rememberService', 'travelWagesService', function (stateService, utilityService, rememberService, travelWagesService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                filtervalue: ''
//            };

//            vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filtervalue') }
//                ],
//                setting: {},
//                itemsListTravelWages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await travelWagesService.getTravelWages())[0];
//            }
            
//            async function loadTravelWages() {
//                vm.model.itemsListTravelWages = await travelWagesService.listTravelWages();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'filtervalue':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'filtervalue':
//                        vm.model.setting.filtervalue = '';

//                        if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'travelwage':
//                        go({ travelwage_id: '+' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'filtervalue':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.filtervalue) !== true) return;

//                        vm.model.setting.filtervalue = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                        if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'filtervalue':
//                        if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                        if (vm.model.setting.filtervalue > '') rememberFunc('filtervalue');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadTravelWages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
